import { useCallback, useState } from 'react';
import { WfeButtonField } from '@scale/shared/types/params/textcollection';
import { WfeButtonFieldAnnotation } from '@scale/shared/types/response/textcollection';
import { makeStyles } from 'design-system/styles';
import { Button } from '@scale/scaleui';
import { useAsync } from 'react-use-v13';
import apiFetch from '@scale/frontend-lib/api-fetch';
import logger from '@scale/frontend-lib/logging';

interface WfeButtonFieldSectionProps {
  field: WfeButtonField;
  annotation: WfeButtonFieldAnnotation;
  setAnnotation: (annotation: WfeButtonFieldAnnotation) => void;
  disabled?: boolean;
}

export default function WfeButtonFieldSection(props: WfeButtonFieldSectionProps) {
  const [url, setUrl] = useState<string | undefined>(props.field.buttonUrl);
  useAsync(async () => {
    if (props.field.isDolphin) {
      const { url: fetchedUrl } = await apiFetch(null, `/internal/dolphin/dolphinWfeButtonUrl`);
      if (fetchedUrl) {
        setUrl(fetchedUrl);
      } else {
        logger.error('[WfeButtonFieldSection] Failed to get task url for dolphin task');
      }
    }
  }, [props.field.isDolphin]);

  const onClick = useCallback(() => {
    if (!url) {
      return;
    }
    window.open(url, '_blank');
    const newAnnotation: WfeButtonFieldAnnotation = {
      ...props.annotation,
      response: [
        {
          isClicked: true,
        },
      ],
    };
    props.setAnnotation(newAnnotation);
  }, [props.setAnnotation, props.annotation, url]);

  const classes = useStyles();

  return (
    <div>
      <div className={classes.title}>{props.field.title}</div>
      {props.field.description && (
        <div className={classes.description}>{props.field.description}</div>
      )}
      <div className={classes.buttonContainer}>
        <Button variant="primary" size="sm" onClick={onClick} disabled={props.disabled || !url}>
          {props.field.buttonLabel}
        </Button>
      </div>
    </div>
  );
}

const useStyles = makeStyles(theme => ({
  title: {
    color: '#000000',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
  },
  description: {
    color: theme.colors.gray50,
    marginBottom: 16,
    fontSize: 12,
  },
  buttonContainer: {
    marginTop: 12,
  },
}));
